import styled from 'styled-components';

const StyledEGiftCard = styled.section`
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
    text-align: center;
  };
  table{
    width:80%;
    float:right;
    text-align:left;
    border-spacing: 0;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width:100%;
      padding:0px 20px;
    };
    h2{
      font-size: 24px
    }
    td{
      border:${(props) => props.theme.lightGray} solid 1px;
      padding:10px;
    }
    th{
      padding:10px;
    }
  }
  .offer_card{
    position: relative;
    display:inline-block;
    margin-bottom:20px;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      margin:0px;
    };
    h2{
      font-size:13px;
      color: ${(props) => props.theme.secondaryColor};
      b{
        color: ${(props) => props.theme.blackColor};
      }
    }
    img{
      border-radius:15px;
      margin-bottom:30px;
      width:100%;
      height: 200px !important;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        width:100%;
      };
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
        height: auto !important;
      };
    }
    .product_img{
      width:100%;
      border-radius:15px;
      position: relative;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        width:90%;
        margin: 0 auto;
        float: none;
      };
      &:hover{
        .tooltiptext {
          visibility: visible;
        }
      }
      .tooltiptext {
        visibility: hidden;
        width: 450px;
        background-color: ${(props) => props.theme.lightWhite};
        color: ${(props) => props.theme.whiteColor};
        text-align: left;
        border-radius: 6px;
        padding: 10px;

        /* Position the tooltip */
        position: absolute;
        z-index: 1;
        right: -400px;
        top: -40px;
        transition: all 0.5s ease;
      }
      .ribbon {
        position: absolute;
        left: -5px; top: -5px;
        z-index: 1;
        overflow: hidden;
        width: 75px; height: 75px;
        text-align: right;  
      }
      .ribbon span {
        font-size: 14px;
        font-weight: bold;
        color: ${(props) => props.theme.whiteColor};
        text-transform: uppercase;
        text-align: center;
        line-height: 20px;
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        width: 100px;
        display: block;
        background: #79A70A;
        background: linear-gradient(#C90000 0%, #A70000 100%);
        box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
        position: absolute;
        top: 19px; left: -21px;
      }
      .ribbon span::before {
        content: "";
        position: absolute; left: 0px; top: 100%;
        z-index: -1;
        border-left: 3px solid #A70000;
        border-right: 3px solid ${(props) => props.theme.transparentColor};
        border-bottom: 3px solid ${(props) => props.theme.transparentColor};
        border-top: 3px solid #A70000;
      }
      .ribbon span::after {
        content: "";
        position: absolute; right: 0px; top: 100%;
        z-index: -1;
        border-left: 3px solid ${(props) => props.theme.transparentColor};
        border-right: 3px solid #A70000;
        border-bottom: 3px solid ${(props) => props.theme.transparentColor};
        border-top: 3px solid #A70000;
      }
      img{
        width:100%;
      }
      .share{
        position: absolute;
        right: 0;
        top: 4px;
        padding: 20px;
        .fa{
          color: ${(props) => props.theme.whiteColor};
          font-size:22px;
          margin-bottom:15px;
          text-shadow: 0px 0px 5px rgba(150, 150, 150, 1);
        }
      }
    }
    .price{
      width:80%;
      float:right;
      @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        width:100%;
        padding:0px 20px;
      };
      h2{
        font-size:14px;
        color: ${(props) => props.theme.lightGray};
      b{
        color: ${(props) => props.theme.blackColor};
      }
    }
    span{
      color: ${(props) => props.theme.primaryColor};
      font-weight:bold;
      font-size:24.5px;
    }
    strike{
      color: ${(props) => props.theme.mediumGrey};
      margin: 0px 20px;
      font-size: 13px;
      font-weight: 600
    }
    b{
      font-weight:normal;
      font-weight: 600;
      font-size: 13px;
      color: ${(props) => props.theme.blackColor};
    }
  }
  .footer{
    width:80%;
    float:right;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width:100%;
      padding:0px 20px;
    };
    h2{
      font-size: 13px;
      color: ${(props) => props.theme.mediumGrey};
      b{
        font-weight: bold
      }
    }
  }
}
`;

export default StyledEGiftCard;



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/StyledEGiftCard.js